import { render, staticRenderFns } from "./homeSwiper.vue?vue&type=template&id=37461d0c&scoped=true"
import script from "./homeSwiper.vue?vue&type=script&lang=js"
export * from "./homeSwiper.vue?vue&type=script&lang=js"
import style0 from "./homeSwiper.vue?vue&type=style&index=0&id=37461d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37461d0c",
  null
  
)

export default component.exports